<template>
  <div class="tree-wrapper">
    <v-card class="left-side-edit-tree">
      <v-container fluid>
        <div class="link-control mt-4">
          <a
            href="#"
            v-show="userCanDelete"
            class="abbrechen"
            @click.prevent="openDeleteDialog"
          >
            <img src="../../../assets/images/delete-icon.png" alt="" />
            <span>Löschen</span>
          </a>
          <a href="#" class="abbrechen" @click.prevent="cancelDialog = true">Abbrechen</a>
        </div>

        <v-sheet class="mx-auto">
          <!-- Bereich -->
          <v-form ref="bereichForm" class="bereich-form">
            <h2>Bereichskoordinaten</h2>
            <div style="width:100%;border: 1px solid #494949;margin-top:10px"></div>

            <div
              class="populated-coordinates"
              v-for="(item, index) in clonedCoordinates"
              :key="`coord-${index}`"
              v-bind="item.classes"
            >
              <v-row class="mt-4">
                <v-col cols="12">
                  <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                      <span class="number">{{ index + 1 }}</span>
                      <span class="koordinaten">Koordinaten:</span>
                    </div>
                    <div style="cursor:pointer" v-if="clonedCoordinates.length > 3" @click="deleteCordinate(index)">
                      <img src="../../../assets/images/close_white.png" alt="close" />
                    </div>
                  </div>

                  <div style="width:100%;border: 1px solid #494949;margin-top:10px"></div>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="6">
                  <v-text-field
                    v-model="item.inputs.input1"
                    outlined
                    clearable
                    hide-details
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="item.inputs.input2"
                    outlined
                    clearable
                    hide-details
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="12">
                  <div style="width:100%;border: 1px solid #494949;margin-top:0px"></div>
                  <div class="add-new-user">
                    <div class="form-control-add-new">
                      <img
                        src="../../../assets/images/plus_Black.png"
                        alt="plus"
                        style="width: 15px; height: 15px"
                      />
                      <a @click.prevent="cloneForm(index)">Neuen Punkt hinzufügen</a>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-row class="mt-6">
              <v-col cols="12">
                <h2>Stammdaten</h2>
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="6">
                <label>BaumID*</label>
                <v-text-field
                  v-model="createArea.name"
                  :rules="nameRules"
                  outlined
                  clearable
                  hide-details
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label>Baumart*</label>
                <v-autocomplete
                  v-model="selectedTreeTypeId"
                  outlined
                  label="Suche"
                  :items="treeType"
                  item-value="id"
                  :item-text="i => `${i.abbreviation} - ${i.latinName} - ${i.germanName}`"
                  :rules="[v => !!v || 'Artikel ist erforderlich']"
                  @change="selectTreeTypeId(selectedTreeTypeId)"
                  clearable
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row class="mt-12">
              <v-col cols="12">
                <label>Sozialgefüge</label>
                <v-select
                  v-model="selectedMeaningTypeId"
                  :items="meaningTypes"
                  item-value="id"
                  :item-text="i => `${i.name}/${i.abbreviation}`"
                  outlined
                  clearable
                  hide-details
                  required
                  @change="selectedMeaning(selectedMeaningTypeId)"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-checkbox v-model="createArea.striking" label="Markant"></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-checkbox v-model="createArea.privat" label="Privat"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-checkbox v-model="createArea.streetTree" label="Strassenbaum"></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-checkbox v-model="createArea.protectedTree" label="Geschützt"></v-checkbox>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col cols="6">
                <label>Keimjahr</label>
                <DateInput
                  v-model="selectedDateKemjahr"
                  :text-field-props="{rules: dateRulesAtLeastOne}"
                  :date-picker-props="{input: formattedDateKemjahr}"
                  key="Keimjahr"
                />
              </v-col>
              <v-col cols="6">
                <label>Pflanzdatum</label>
                <DateInput
                  v-model="selectedDatePflanzdate"
                  :text-field-props="{rules: dateRulesAtLeastOne}"
                  :date-picker-props="{input: formattedDatePflanzdate}"
                  key="Pflanzdatum"
                />
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="6">
                <label>Fälldatum</label>
                <DateInput
                  v-model="selectedFullDate"
                  :date-picker-props="{input: formattedDateFullDate}"
                  key="Fälldatum"
                />
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="12">
                <h2 class="technical-date">Technische Daten</h2>
              </v-col>
            </v-row>

            <div class="populated" v-for="(item, index) in technicalSepcs" :key="`td-${index}`">
              <v-row class="mt-4">
                <v-col cols="12">
                  <div class="d-flex justify-space-between align-center" style="cursor:pointer">
                    <span class="number">{{ index + 1 }}</span>
                    <div v-if="technicalSepcs.length > 1" @click="deleteTechnicalSpecsContainer(index)">X</div>
                  </div>
                  <div style="width:100%;border: 1px solid #494949;margin-top:10px"></div>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="6">
                  <label>Anzahl Stämme</label>
                  <v-text-field
                    :rules="[numberRule]"
                    v-model="item.inputs.numberOfTrunks"
                    outlined
                    clearable
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <label>Erfassungdatum*</label>
                  <DateInput
                    v-model="selectedEntryDate[index]"
                    :text-field-props="{rules: [v => !!v || 'Item is required']}"
                    :date-picker-props="{input: v => formattedDateEntryDate(v, index)}"
                    key="Erfassungdatum"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="4">
                  <label>Stammumfang</label>
                  <DecimalNumberInput v-model="item.inputs.perimeterTrunk" append-icon="cm" />
                </v-col>
                <v-col cols="4">
                  <label>Baumhöhe</label>
                  <DecimalNumberInput v-model="item.inputs.treeHeight" append-icon="m" />
                </v-col>
                <v-col cols="4">
                  <label>Kronendurchmesser</label>
                  <DecimalNumberInput v-model="item.inputs.crownDiameter" append-icon="m" />
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="6">
                  <label>Stammneigung</label>
                  <v-text-field
                    :rules="[numberRule]"
                    v-model="item.inputs.trunkSlope"
                    outlined
                    clearable
                    hide-details
                    append-icon="O"
                    class="custom-prefix-one-letter"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <label>Stammneigung Richtung</label>
                  <v-select
                    v-model="selectedSlopeTypes[index]"
                    :items="selectedDirectionSlope"
                    item-value="value"
                    :item-text="i => `${i.text}`"
                    outlined
                    clearable
                    hide-details
                    @change="selectedSlope(selectedSlopeTypes[index], index)"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="4">
                  <label>Wurzelraum</label>
                  <v-select
                    v-model="rootSpaceTypeId[index]"
                    :items="rootSpaceTypes"
                    item-value="id"
                    :item-text="i => `${i.abbreviation} - ${i.name}`"
                    outlined
                    clearable
                    hide-details
                    @change="selectedRoot(rootSpaceTypeId[index], index)"
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <label>Fläche</label>
                  <v-text-field
                    :rules="[numberRule]"
                    v-model="item.inputs.surface"
                    outlined
                    clearable
                    hide-details
                    append-icon="㎡"
                    class="custom-prefix-one-letter"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <label>Breite</label>
                  <v-text-field
                    :rules="[numberRule]"
                    v-model="item.inputs.wide"
                    outlined
                    clearable
                    hide-details
                    append-icon="m"
                    class="custom-prefix-one-letter"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="6">
                  <label>Umrandung</label>
                  <v-select
                    v-model="borderTypeId[index]"
                    :items="borderTypes"
                    item-value="id"
                    :item-text="i => `${i.abbreviation} - ${i.name}`"
                    outlined
                    clearable
                    hide-details
                    @change="selectedBorder(borderTypeId[index], index)"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <label>Bedeckung</label>
                  <v-select
                    v-model="coverageTypeId[index]"
                    :items="coverageTypes"
                    item-value="id"
                    :item-text="i => `${i.abbreviation} - ${i.name}`"
                    outlined
                    clearable
                    hide-details
                    @change="selectedCover(coverageTypeId[index], index)"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="6">
                  <label>Bewuchs</label>
                  <v-autocomplete
                    v-model="vegetationTypeId[index]"
                    :items="vegetationTypes"
                    item-value="id"
                    :item-text="i => `${i.abbreviation} - ${i.name}`"
                    outlined
                    clearable
                    hide-details
                    label="Suche"
                    @change="selectedVegetable(vegetationTypeId[index], index)"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="12">
                  <label>Info</label>
                  <v-textarea
                    rows="2"
                    v-model="item.inputs.info"
                    outlined
                    clearable
                    hide-details
                    variant="solo"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <div class="add-new-user">
                    <img src="../../../assets/images/plus_Black.png" alt="plus" />
                    <a href="#" @click.prevent="cloneTechnicalSpecs(index)">Neue Daten hinzufügen</a>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="d-flex flex-column mt-6 mb-12">
              <v-row>
                <v-col cols="6">
                  <v-btn class="save-btn mt-4" block @click="updateArea">Speichern</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn class="cancel-btn mt-4" block @click="cancelDialog = true">Abbrechen</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-sheet>
      </v-container>
    </v-card>

    <!-- RIGHT: map -->
    <v-card style="width: 50vw; height: calc(100vh - 124px); z-index: 0;">
      <TreeMap
        :regions="mapRegions"
        :coordinates="inventarCoordinates"
        :whichForm="'bereich'"
        :treeCoordinates="null"
        :from="'edit'"
        @latlngs-updatedArea="handleEventLatLngArea"
      />
    </v-card>

    <!-- Delete popup -->
    <div class="delete-popup" v-show="deleteDialog" ref="deletePopup">
      <div class="popup-holder">
        <v-icon size="36" class="close-popup" @click="deleteDialog = false">mdi mdi-close</v-icon>
        <p class="title">Bereich Löschen</p>

        <div class="description-holder">
          <v-icon color="#C82210" class="popup-icon">mdi mdi-trash-can-outline</v-icon>
          <p class="description">Wollen Sie diesen Bereich wirklich löschen?</p>
        </div>

        <div class="buttons">
          <v-btn size="x-large" height="54px" class="cancel-btn" @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn size="x-large" height="54px" color="#c82210" class="delete-btn" @click="deleteArea">Löschen</v-btn>
        </div>
      </div>
    </div>

    <!-- Cancel popup -->
    <div class="cancel-popup" v-if="cancelDialog" ref="cancelPopup">
      <div class="popup-holder">
        <v-icon size="36" class="close-popup" @click="neinClickHandler">mdi mdi-close</v-icon>
        <p class="title">Abbrechen</p>
        <div class="description-holder">
          <v-icon color="#C82210" class="popup-icon">mdi mdi-alert-outline</v-icon>
          <p class="description">Wollen Sie die Aktion wirklich Abbrechen?</p>
        </div>
        <div class="buttons">
          <v-btn size="x-large" height="54px" color="#c82210" class="delete-btn" @click="redirectToList">Ja</v-btn>
          <v-btn size="x-large" height="54px" class="cancel-btn" @click="neinClickHandler">Nein</v-btn>
        </div>
      </div>
    </div>

    <!-- Success + loader + snackbar -->
    <v-alert type="success" elevation="20" v-show="editAreaDialog" class="alert">
      Der Bereich wurde erfolgreich aktualisiert.
    </v-alert>
    <CustomLoader v-show="isLoading" />
    <v-snackbar v-model="snackbar" :timeout="timeout" top color="danger">
      <div>{{ snackbarMessage }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn color="" text v-bind="attrs" @click.prevent="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import TreeMap from "./map/TreeMap.vue";
import DateInput from "@/components/base/DateInput.vue";
import DecimalNumberInput from "@/components/base/DecimalNumberInput.vue";
import CustomLoader from "@/components/custom_components/CustomLoader.vue";

export default {
  name: "EditArea",
  components: { TreeMap, DateInput, DecimalNumberInput, CustomLoader },
  data() {
    return {
      timeout: 2000,
      snackbar: false,
      snackbarMessage: "",
      isLoading: false,
      userCanDelete: false,
      editAreaDialog: false,
      cancelDialog: false,
      deleteDialog: false,

      // core model for UpdateAreaDto
      createArea: {
        id: null,
        name: "",
        inventoryId: null,
        treeTypeId: null,
        meaningTypeId: null,
        striking: false,
        privat: false,
        streetTree: false,
        protectedTree: false,
        treeLatitude: 0,
        treeLongitude: 0,
        germinationDate: null,
        plantingDate: null,
        dropDate: null,
        areaRegions: [],
        technicalDatas: []
      },

      // Lookups
      treeType: [],
      meaningTypes: [],
      coverageTypes: [],
      vegetationTypes: [],
      borderTypes: [],
      rootSpaceTypes: [],

      // Selections
      selectedTreeTypeId: null,
      selectedMeaningTypeId: null,

      // Dates
      selectedDateKemjahr: "",
      selectedDatePflanzdate: "",
      selectedFullDate: null,
      selectedEntryDate: [],

      // Direction options
      directionSlope: { S: "S", SW: "SW", W: "W", NW: "NW", N: "N", NO: "NO", O: "O", SO: "SO" },
      selectedSlopeTypes: [],

      // per-index id holders / values
      rootSpaceTypeId: [],
      borderTypeId: [],
      coverageTypeId: [],
      vegetationTypeId: [],

      // UI arrays
      technicalSepcs: [
        {
          inputs: {
            id: 0,
            numberOfTrunks: null,
            entryDate: null,
            perimeterTrunk: null,
            treeHeight: null,
            crownDiameter: null,
            trunkSlope: null,
            trunkSlopeDirectionType: null,
            rootSpaceTypeId: 0,
            surface: null,
            wide: null,
            borderTypeId: 0,
            coverageTypeId: 0,
            vegetationTypeId: 0,
            info: ""
          },
          classes: [{ class: "populated" }],
          isDuplicatedWith: null
        }
      ],
      clonedCoordinates: [
        {
          inputs: { input1: null, isValidInput1: true, input2: null, isValidInput2: true },
          classes: [{ class: "populated-coordinates" }],
          isDuplicatedWith: null
        },
        {
          inputs: { input1: null, isValidInput1: true, input2: null, isValidInput2: true },
          classes: [{ class: "populated-coordinates" }],
          isDuplicatedWith: null
        },
        {
          inputs: { input1: null, isValidInput1: true, input2: null, isValidInput2: true },
          classes: [{ class: "populated-coordinates" }],
          isDuplicatedWith: null
        }
      ],
      areaRegionIds: [],

      // misc
      mapRegions: [],
      nameRules: [v => !!v || "Name is required"],
      numberRule: v => v === null || /^\d+$/.test(v) || "Nur Zahlen sind erlaubt",

      // navigation guard helpers
      allowNavigate: false,
      nextRoute: null
    };
  },
  computed: {
    ...mapGetters(["inventarId", "inventarCoordinates"]),
    selectedDirectionSlope() {
      return Object.entries(this.directionSlope).map(([value, text]) => ({ value, text }));
    },
    dateRulesAtLeastOne() {
      return [
        () => {
          const hasAny =
            (this.selectedDateKemjahr && this.selectedDateKemjahr !== "") ||
            (this.selectedDatePflanzdate && this.selectedDatePflanzdate !== "");
          return hasAny || "Date is required";
        }
      ];
    },
    formattedDateKemjahr() {
      if (this.selectedDateKemjahr) {
        const d = new Date(this.selectedDateKemjahr);
        return (this.createArea.germinationDate = d.toISOString());
      }
      return "";
    },
    formattedDatePflanzdate() {
      if (this.selectedDatePflanzdate) {
        const d = new Date(this.selectedDatePflanzdate);
        return (this.createArea.plantingDate = d.toISOString());
      }
      return "";
    },
    formattedDateFullDate() {
      if (this.selectedFullDate !== null) {
        const d = new Date(this.selectedFullDate);
        return (this.createArea.dropDate = d.toISOString());
      }
      return null;
    }
  },
  methods: {
    fetchMapRegionTrees() {
      axios
        .get(`/api/Tree/MapRegion/${this.inventarId}`)
        .then(r => (this.mapRegions = r.data.treeRegions))
        .catch(console.error);
    },
    loadLookups() {
      axios.get(`/api/TreeType/GetAll`).then(r => (this.treeType = r.data)).catch(console.error);
      axios.get(`/api/Tree/GetAllMeaningType`).then(r => (this.meaningTypes = r.data)).catch(console.error);
      axios.get(`/api/CoverageType/GetAll`).then(r => (this.coverageTypes = r.data)).catch(console.error);
      axios.get(`/api/VegetationType/GetAll`).then(r => (this.vegetationTypes = r.data)).catch(console.error);
      axios.get(`/api/Tree/GetAllBorderType`).then(r => (this.borderTypes = r.data)).catch(console.error);
      axios.get(`/api/Tree/GetAllRootSpaceType`).then(r => (this.rootSpaceTypes = r.data)).catch(console.error);
    },
    mapSlopeStrToNum(s) {
      switch (s) {
        case "S": return 1;
        case "SW": return 2;
        case "W": return 3;
        case "NW": return 4;
        case "N": return 5;
        case "NO": return 6;
        case "O": return 7;
        case "SO": return 8;
        default: return null;
      }
    },
    mapSlopeNumToStr(n) {
      const t = { 1: "S", 2: "SW", 3: "W", 4: "NW", 5: "N", 6: "NO", 7: "O", 8: "SO" };
      return t[n] ?? null;
    },

    selectedMeaning(id) { this.createArea.meaningTypeId = id ?? 0; },
    selectTreeTypeId(id) { this.createArea.treeTypeId = id ?? 0; },
    selectedSlope(v, i) { this.technicalSepcs[i].inputs.trunkSlopeDirectionType = v ?? null; },
    selectedRoot(v, i) { this.technicalSepcs[i].inputs.rootSpaceTypeId = v ?? 0; },
    selectedBorder(v, i) { this.technicalSepcs[i].inputs.borderTypeId = v ?? 0; },
    selectedCover(v, i) { this.technicalSepcs[i].inputs.coverageTypeId = v ?? 0; },
    selectedVegetable(v, i) { this.technicalSepcs[i].inputs.vegetationTypeId = v ?? 0; },

    formattedDateEntryDate(val, index) {
      if (val) {
        const d = new Date(val);
        this.technicalSepcs[index].inputs.entryDate = d.toISOString();
      }
      return "";
    },

    handleEventLatLngArea(lnglat) {
      this.areaRegionIds = [];
      if (lnglat && lnglat.length) {
        this.clonedCoordinates = lnglat.map(([lat, lng]) => ({
          inputs: { input1: lat, isValidInput1: true, input2: lng, isValidInput2: true },
          classes: [{ class: "populated-coordinates" }],
          isDuplicatedWith: null
        }));
      } else {
        this.clonedCoordinates = this.clonedCoordinates.slice(0, 3);
      }
    },

    deleteCordinate(index) {
      this.clonedCoordinates = this.clonedCoordinates.filter((_, i) => i !== index);
      this.areaRegionIds = this.areaRegionIds.filter((_, i) => i !== index);
    },
    cloneForm(index) {
      this.clonedCoordinates.splice(index + 1, 0, {
        inputs: { input1: null, isValidInput1: true, input2: null, isValidInput2: true },
        classes: [{ class: "populated-coordinates" }],
        isDuplicatedWith: null
      });
      this.areaRegionIds.splice(index + 1, 0, 0);
    },

    addKoordinates() {
      const unique = [];
      this.clonedCoordinates.forEach((el, idx, arr) => {
        const isDup = unique.some(u => u.latitude === el.inputs.input1 && u.longitude === el.inputs.input2);
        if (!isDup) {
          unique.push({ latitude: el.inputs.input1, longitude: el.inputs.input2 });
          el.isDuplicatedWith = null;
        } else {
          el.isDuplicatedWith = arr.findIndex(
            f => f.inputs.input1 === el.inputs.input1 && f.inputs.input2 === el.inputs.input2
          );
        }
      });
      this.createArea.areaRegions = unique;
    },
    addTechnicalSpecs() {
      const unique = [];
      this.technicalSepcs.forEach((el, idx, arr) => {
        const i = el.inputs;
        const isDup = unique.some(u =>
          u.trunksNumber === i.numberOfTrunks &&
          u.acquisitionDate === i.entryDate &&
          u.trunkCircumference === i.perimeterTrunk &&
          u.treeHeight === i.treeHeight &&
          u.crownDiameter === i.crownDiameter &&
          u.trunkSlope === i.trunkSlope &&
          u.trunkSlopeDirectionType === this.mapSlopeStrToNum(i.trunkSlopeDirectionType) &&
          u.rootSpaceTypeId === i.rootSpaceTypeId &&
          u.area === i.surface &&
          u.wide === i.wide &&
          u.borderTypeId === i.borderTypeId &&
          u.coverageTypeId === i.coverageTypeId &&
          u.vegetationTypeId === i.vegetationTypeId &&
          u.info === i.info
        );

        if (!isDup) {
          unique.push({
            id: i.id || 0,
            trunksNumber: i.numberOfTrunks,
            acquisitionDate: i.entryDate,
            trunkCircumference: i.perimeterTrunk,
            treeHeight: i.treeHeight,
            crownDiameter: i.crownDiameter,
            trunkSlope: i.trunkSlope,
            trunkSlopeDirectionType: this.mapSlopeStrToNum(i.trunkSlopeDirectionType),
            rootSpaceTypeId: i.rootSpaceTypeId,
            area: i.surface,
            wide: i.wide,
            borderTypeId: i.borderTypeId,
            coverageTypeId: i.coverageTypeId,
            vegetationTypeId: i.vegetationTypeId,
            info: i.info
          });
          el.isDuplicatedWith = null;
        } else {
          el.isDuplicatedWith = arr.findIndex(f => f.inputs === i); // UI only
        }
      });
      this.createArea.technicalDatas = unique;
    },
    deleteTechnicalSpecsContainer(index) {
      this.technicalSepcs = this.technicalSepcs.filter((_, i) => i !== index);
      this.selectedEntryDate = this.selectedEntryDate.filter((_, i) => i !== index);
      this.rootSpaceTypeId = this.rootSpaceTypeId.filter((_, i) => i !== index);
      this.borderTypeId = this.borderTypeId.filter((_, i) => i !== index);
      this.coverageTypeId = this.coverageTypeId.filter((_, i) => i !== index);
      this.vegetationTypeId = this.vegetationTypeId.filter((_, i) => i !== index);
      this.selectedSlopeTypes = this.selectedSlopeTypes.filter((_, i) => i !== index);
    },
    cloneTechnicalSpecs(index) {
      this.selectedEntryDate[index + 1] = null;
      this.technicalSepcs.splice(index + 1, 0, {
        inputs: {
          id: 0,
          numberOfTrunks: null,
          entryDate: null,
          perimeterTrunk: null,
          treeHeight: null,
          crownDiameter: null,
          trunkSlope: null,
          trunkSlopeDirectionType: null,
          rootSpaceTypeId: 0,
          surface: null,
          wide: null,
          borderTypeId: 0,
          coverageTypeId: 0,
          vegetationTypeId: 0,
          info: ""
        },
        classes: [{ class: "populated" }],
        isDuplicatedWith: null
      });
    },

    getUpdateArea() {
      const areaId = this.$route.params.areaId;
      axios
        .get(`/api/Tree/GetArea/${this.inventarId}/${areaId}`)
        .then(({ data }) => {
          this.createArea.id = data.id;
          this.createArea.name = data.name;
          this.createArea.inventoryId = data.inventoryId;
          this.createArea.germinationDate = data.germinationDate;
          this.createArea.plantingDate = data.plantingDate;
          this.createArea.dropDate = data.dropDate;
          this.createArea.striking = data.striking;
          this.createArea.privat = data.privat;
          this.createArea.streetTree = data.streetTree;
          this.createArea.protectedTree = data.protectedTree;

          this.selectedTreeTypeId = data.treeTypeId;
          this.selectedMeaningTypeId = data.meaningTypeId;
          this.createArea.treeTypeId = data.treeTypeId;
          this.createArea.meaningTypeId = data.meaningTypeId;

          this.selectedDateKemjahr = data.germinationDate ? data.germinationDate.split("T")[0] : "";
          this.selectedDatePflanzdate = data.plantingDate ? data.plantingDate.split("T")[0] : "";
          this.selectedFullDate = data.dropDate ? data.dropDate.split("T")[0] : null;

          const ar = data.areaRegion || data.areaRegionDto || data.areaRegionDtos || data.areaRegionList || data.areaRegion; // tolerate shapes
          const regions = Array.isArray(data.areaRegion) ? data.areaRegion : (data.areaRegion || data.areaRegions || []);
          this.clonedCoordinates = [];
          this.areaRegionIds = [];
          (regions || []).forEach(r => {
            this.clonedCoordinates.push({
              inputs: { input1: r.latitude, isValidInput1: true, input2: r.longitude, isValidInput2: true },
              classes: [{ class: "populated-coordinates" }],
              isDuplicatedWith: null
            });
            this.areaRegionIds.push(r.id || 0);
          });
          if (this.clonedCoordinates.length < 3) {
            while (this.clonedCoordinates.length < 3) {
              this.clonedCoordinates.push({
                inputs: { input1: null, isValidInput1: true, input2: null, isValidInput2: true },
                classes: [{ class: "populated-coordinates" }],
                isDuplicatedWith: null
              });
              this.areaRegionIds.push(0);
            }
          }

          this.technicalSepcs = [];
          this.selectedEntryDate = [];
          this.rootSpaceTypeId = [];
          this.borderTypeId = [];
          this.coverageTypeId = [];
          this.vegetationTypeId = [];
          this.selectedSlopeTypes = [];

          (data.technicalDatas || []).forEach((td, index) => {
            this.technicalSepcs[index] = {
              inputs: {
                id: td.id || 0,
                numberOfTrunks: td.trunksNumber,
                entryDate: td.acquisitionDate,
                perimeterTrunk: td.trunkCircumference,
                treeHeight: td.treeHeight,
                crownDiameter: td.crownDiameter,
                trunkSlope: td.trunkSlope,
                trunkSlopeDirectionType: this.mapSlopeNumToStr(td.trunkSlopeDirectionType),
                rootSpaceTypeId: td.rootSpaceTypeId,
                surface: td.area,
                wide: td.wide,
                borderTypeId: td.borderTypeId,
                coverageTypeId: td.coverageTypeId,
                vegetationTypeId: td.vegetationTypeId,
                info: td.info
              },
              classes: [{ class: "populated" }],
              isDuplicatedWith: null
            };
            this.selectedEntryDate[index] = td.acquisitionDate;
            this.rootSpaceTypeId[index] = td.rootSpaceTypeId;
            this.borderTypeId[index] = td.borderTypeId;
            this.coverageTypeId[index] = td.coverageTypeId;
            this.vegetationTypeId[index] = td.vegetationTypeId;
            this.selectedSlopeTypes[index] = this.mapSlopeNumToStr(td.trunkSlopeDirectionType);
          });
        })
        .catch(err => {
          console.error(err);
          this.snackbar = true;
          this.snackbarMessage = "Bereich konnte nicht geladen werden.";
        });
    },

    updateArea() {
      this.addKoordinates();
      this.addTechnicalSpecs();

      if (!this.createArea.areaRegions || this.createArea.areaRegions.length < 3) {
        this.snackbar = true;
        this.snackbarMessage = "Bitte fügen Sie mindestens 3 Koordinaten hinzu.";
        return;
      }

      const valid = this.$refs.bereichForm.validate();
      if (!valid) {
        this.snackbar = true;
        this.snackbarMessage = "Bitte füllen Sie alle erforderlichen Felder aus!";
        return;
      }

      const areaRegionsWithIds = this.createArea.areaRegions.map((p, i) => ({
        id: this.areaRegionIds[i] || 0,
        latitude: p.latitude,
        longitude: p.longitude
      }));

      const payload = {
        id: this.createArea.id,
        name: this.createArea.name,
        inventoryId: this.createArea.inventoryId,
        treeTypeId: this.createArea.treeTypeId,
        meaningTypeId: this.createArea.meaningTypeId,
        striking: this.createArea.striking,
        privat: this.createArea.privat,
        streetTree: this.createArea.streetTree,
        protectedTree: this.createArea.protectedTree,
        treeLatitude: this.createArea.treeLatitude || 0,
        treeLongitude: this.createArea.treeLongitude || 0,
        germinationDate: this.createArea.germinationDate,
        plantingDate: this.createArea.plantingDate,
        dropDate: this.createArea.dropDate,
        areaRegions: areaRegionsWithIds,
        technicalDatas: this.createArea.technicalDatas
      };

      this.snackbar = false;
      this.snackbarMessage = "";

      this.isLoading = true;

      axios
        .put(`/api/Tree/UpdateArea`, payload)
        .then(r => {
          this.isLoading = false;

          if (r && r.status === 200) {
            this.editAreaDialog = true;

            setTimeout(() => {
              this.allowNavigate = true;
              this.$router.push({
                name: "Baumliste",
                params: { isTree: false, areaId: r.data.data, treeId: 0 }
              });
            }, 1500);
          }
        })
        .catch(err => {
          this.isLoading = false;

          const status = err?.response?.status;
          const data = err?.response?.data;

          if (status === 409 && data?.code === "TREE_NAME_EXISTS") {
            this.snackbar = true;
            this.snackbarMessage = "Name ist bereits vergeben.";
            return;
          }

          this.snackbar = true;
          this.snackbarMessage = data?.message || "Fehler beim Aktualisieren des Bereichs.";
          console.error(err);
        });
    },

    deleteArea() {
      if (!this.createArea.id) return;
      this.isLoading = true;
      axios
        .delete(`/api/Tree/DeleteArea/${this.createArea.id}`)
        .then(() => {
          this.isLoading = false;
          this.allowNavigate = true;
          this.deleteDialog = false;
          this.$router.back();
        })
        .catch(err => {
          this.isLoading = false;
          console.error(err);
          this.snackbar = true;
          this.snackbarMessage = "Bereich konnte nicht gelöscht werden.";
        });
    },

    openDeleteDialog() { this.deleteDialog = true; },
    redirectToList() {
      this.allowNavigate = true;
      this.$router.push({ name: "Baumliste" });
    },
    neinClickHandler() {
      this.nextRoute = null;
      this.allowNavigate = false;
      this.cancelDialog = false;
    }
  },
  created() {
    this.loadLookups();
    this.fetchMapRegionTrees();
    this.userCanDelete = this.$route.params?.canDelete ?? false;
    this.createArea.inventoryId = this.inventarId;
    this.getUpdateArea();
  },
  beforeRouteLeave(to, from, next) {
    if (this.allowNavigate) next();
    else {
      this.nextRoute = to;
      this.cancelDialog = true;
    }
  }
};
</script>

<style lang="scss">
.v-snack--top { top: 10% !important; }
.alert {
  position: fixed !important;
  width: 100% !important;
  max-width: 784px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  padding: 40px 100px !important;
}
.tree-wrapper {
  display: flex;
  width: 100%;
  height: calc(100vh - 124px);
  box-sizing: border-box;

  .left-side-edit-tree {
    width: 50vw;
    border-right: 20px solid #757575;
    box-sizing: border-box;
    overflow: scroll;

    .link-control {
      display: flex;
      justify-content: space-between;

      .abbrechen {
        display: flex;
        align-items: flex-end;
        margin-right: 30px;
        margin-bottom: 20px;
        float: right;
        color: #c82210;
        text-decoration: underline;

        img { margin-right: 4px; margin-bottom: 3px; }
      }
    }

    &::-webkit-scrollbar { width: 3px; }
    &::-webkit-scrollbar-thumb { background-color: #1db954; border-radius: 3px; }
    &::-webkit-scrollbar-track { background-color: #494949; }
  }

  .number {
    display: flex;
    width: 35px; height: 35px;
    border: 1px solid #1db954; border-radius: 50%;
    align-items: center; justify-content: center;
    margin-right: 20px; background: #1db954; color: black;
    font-size: 18px; line-height: 27px;
  }

  .technical-date { font-weight: 500 !important; font-size: 25px !important; color: #fff !important; }
  .koordinaten { font-weight: 500; font-size: 18px; color: #fff; }
  .cancel-btn { border: 1px solid #e5e5e5; color: #fff; }
  .save-btn { background-color: #1db954 !important; color: #151914 !important; }
}
.delete-popup, .cancel-popup {
  position: fixed; left: 0; top: 0; right: 0; bottom: 0;
  width: 100vw; height: 100vh; background-color: rgba(0,0,0,.3);
  z-index: 2000; display: flex; align-items: center; justify-content: center;

  .popup-holder {
    display: flex; flex-direction: column; background-color: #1c1e1c;
    width: 662px; max-height: 80%; border-radius: 10px; padding: 30px; position: relative;

    .close-popup { position: absolute; right: 30px; top: 25px; cursor: pointer; }
    .title { text-align: center; }

    .description-holder {
      display: flex; align-items: center; flex-direction: column; justify-content: center;
      height: 200px;

      .popup-icon { margin-bottom: 20px; font-size: 50px; }
      .description { font-size: 18px; line-height: 25px; margin-bottom: 0; text-align: center; }
    }

    .buttons {
      display: flex; align-items: center; justify-content: center; gap: 30px;

      .delete-btn, .cancel-btn { width: 285px; }
      .delete-btn { background: #c82210; color: #fff; }
      .cancel-btn { background: transparent; border: 1px solid #fff; }
    }
  }
}
</style>
